module.exports = __webpack_public_path__ + "img/gg.7398ed3b.png";